<div style="max-width: 600px;">
    <div class="modal-content cnt-dashboard border-0">
        <div class="modal-header pt-3">
            <h2 class="text-1 fs-4 text-center">{{"COMMON.Save_Filter" | translate}}</h2>
            <i type="button" (click)="closeModel(false)"
                class="color-4 fs-2 far fa-times-circle absolute -right-[24px] -top-[24px] m-4"></i>
        </div>
        <form [formGroup]="filterSaveForm">
            <div class="modal-body bg-gris-1 px-5">
                <label class="text-3 mb-2">{{"COMMON.NAME" | translate}}<span class="color-6">
                        *</span></label>
                <input type="text" class="form-control" placeholder="Enter Filter Name" formControlName="title">
            </div>
            <div class="modal-footer j-c-center mt-4 pb-4">
                <div class="btn btn-2 mx-2 custom-padding" (click)="onDismiss()">
                    {{"COMMON.Cancel" | translate}}
                </div>
                <button (click)="saveFilter()" class="btn btn-1 mx-2 btn_continous custom-padding"> {{"COMMON.Save" | translate}}</button>
            </div>
        </form>
    </div>
</div>